module.exports = __webpack_public_path__ + "static/img/2.70d56bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/2.png
// module id = q7nN
// module chunks = 0